import styled from 'styled-components';
export const StyledKey = styled.span.withConfig({
  displayName: "StyledKey",
  componentId: "g5xunh-0"
})(["display:flex;height:16px;min-width:16px;justify-content:center;align-items:center;color:", " !important;border:", ";border-radius:3px;padding:0 2px !important;margin:", ";font-size:14px !important;font-weight:300 !important;visibility:", ";opacity:", ";transition:opacity 0.1s ease-in,visibility 0.1s ease-in !important;transform:translateZ(0);will-change:opacity,visibility;"], ({
  theme
}) => theme.color['border-core-subtle'], ({
  theme
}) => `solid 1px ${theme.color['icon-core-subtle']} !important`, ({
  theme
}) => `0 0 0 ${theme.space['100']} !important`, ({
  isOpen
}) => isOpen ? 'hidden' : 'visible', ({
  isOpen
}) => isOpen ? '0' : '1');